<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/BFmQcy/tc-custom/9781595589484.jpg?1705548153360" alt="This image is the cover for the book Blue Future"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Blue Future
      </h1>
      <p class="bookDescription body article font2">
        <b>Water is a human right: “A</b><b> rousing case for what will be one of the key environmental challenges of the twenty-first century.” —<i>Booklist</i> </b><br/>  <br/> The United Nations has recognized access to water as a basic human right—but there is still much work to be done to stem this growing environmental crisis. In this book, water activist Maude Barlow draws on her extensive experience to lay out a set of key principles that show the way forward to what she calls a “water-secure and water-just world.”<br/>  <br/> Not only does she reveal the powerful players even now impeding the recognition of the human right to water, she argues that water must not become a commodity to be bought and sold on the open market. Focusing on solutions, she includes stories of struggle and resistance from marginalized communities, as well as government policies that work for both people and the planet.<br/>  <br/> At a time when climate change has moved to the top of the national agenda and the stage is being set for unprecedented drought, mass starvation, and the migration of millions of refugees in search of water, <i>Blue Future</i> is an urgent call to preserve our most valuable resource for generations to come.<br/>  <br/> “In a book as clear as a pristine mountain stream, Maude Barlow lays out a practical and inspiring vision for how we can defend water—the source of all life—from the forces of death.” —Naomi Klein, author of <i>The Shock Doctrine</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Maude Barlow
      </h2>
      
      <p class="authorDescription body article">A recipient of Sweden’s Right Livelihood Award and a Lannan­ Cultural Freedom Fellowship, Maude Barlow is head of the Council of Canadians and founder of the Blue Planet Project. The author of sixteen books, including Blue Gold and Blue Covenant (both available from The New Press), she is on the boards of Food & Water Watch and the International Forum on Globalization. She lives in Ottawa.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The New Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?05186a68